/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Navbar_LoginInputs */

const de_auth_navbar_login = /** @type {(inputs: Auth_Navbar_LoginInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden`)
};

/** @type {(inputs: Auth_Navbar_LoginInputs) => LocalizedString} */
const en_auth_navbar_login = de_auth_navbar_login;

/**

* @param {Auth_Navbar_LoginInputs} inputs
* @param {{ locale?: "de" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_navbar_login = /** @type {((inputs?: Auth_Navbar_LoginInputs, options?: { locale?: "de" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Navbar_LoginInputs, { locale?: "de" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_auth_navbar_login(inputs)
	return en_auth_navbar_login(inputs)
});